module.exports = __webpack_public_path__ + "img/roles.96c3457d.svg";